export function useDocumentTitle() {
  // Noop for native platforms
}
